import { Pipe, PipeTransform } from '@angular/core'
import { EmailTypes } from '../secure-email/EmailTypes';

@Pipe({
    name: 'email_type',
})
export class EmailTypeFilterPipe implements PipeTransform {
    transform(type: number) {
        if (type == EmailTypes.email) {
            return 'Email'
        } else if (type == EmailTypes.document_request) {
            return 'Document Request'
        } else if (type == EmailTypes.signature_request) {
            return 'Signature Request'
        }
        else if (type == EmailTypes.approval_request) {
            return 'Approval Request'
        }
        else if (type == EmailTypes.survey) {
            return 'Form Request'
        }
        else if (type == EmailTypes.payment_request) {
            return 'Payment Request'
        } 
        else if (type == EmailTypes.appointment_request) {
            return 'Appointment Request'
        }
        else if (type == EmailTypes.question_request) {
            return 'Question Request'
        }
        else if (type == EmailTypes.checklist_request) {
            return 'Checklist Request'
        }
        return type
    }
}
